/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { interfaces } from 'inversify';
import { fluentProvide } from 'inversify-binding-decorators';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const provideSingleton = <T>(identifier: interfaces.ServiceIdentifier<T>): ((target: any) => any) => {
  return fluentProvide(identifier).inSingletonScope().done();
};
